import { takeLatest, call, put } from 'redux-saga/effects'
import {
    addShiftAPI, declineRequestShiftAPI, requestShiftAPI, shiftAssignEmployeeAPI,
    shiftDetailAPI, shiftListAPI, shiftRemoveEmployeeAPI, updateShiftAPI
} from '../api-requests/shift';
import {
    addShiftRequestError, addShiftRequestSuccess, assignShiftRequestError,
    assignShiftRequestSuccess, declineRequestShiftRequestError, declineRequestShiftRequestSuccess,
    removeShiftEmployeeRequestError, removeShiftEmployeeRequestSuccess, requestShiftRequestError,
    requestShiftRequestSuccess, shiftDetailRequestError, shiftDetailRequestSuccess,
    shiftListRequestError, shiftListRequestSuccess, updateShiftRequestError,
    updateShiftRequestSuccess
} from './shift.action';
import { ShiftActionTypes } from './shift.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';

function* handleUpdateShift({ payload }) {
    try {
        const response = yield call(updateShiftAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateShiftRequestSuccess(decryptedData))
            } else {
                yield put(updateShiftRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(updateShiftRequestError(error.response.data))
    }
}

export function* updateShiftReq() {
    yield takeLatest(ShiftActionTypes.UPDATE_SHIFT_REQUEST, handleUpdateShift)
}

function* handleShiftRemoveEmployee({ payload }) {
    try {
        const response = yield call(shiftRemoveEmployeeAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(removeShiftEmployeeRequestSuccess(decryptedData))
            } else {
                yield put(removeShiftEmployeeRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(removeShiftEmployeeRequestError(error.response.data))
    }
}

export function* shiftRemoveEmployeeReq() {
    yield takeLatest(ShiftActionTypes.SHIFT_REMOVE_EMPLOYEE_REQUEST, handleShiftRemoveEmployee)
}

function* handleShiftList({ payload }) {
    try {
        const response = yield call(shiftListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(shiftListRequestSuccess(decryptedData))
            } else {
                yield put(shiftListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(shiftListRequestError(error.response.data))
    }
}

export function* shiftListReq() {
    yield takeLatest(ShiftActionTypes.SHIFT_LIST_REQUEST, handleShiftList)
}

function* handleShiftDetail({ payload }) {
    try {
        const response = yield call(shiftDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(shiftDetailRequestSuccess(decryptedData))
            } else {
                yield put(shiftDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(shiftDetailRequestError(error.response.data))
    }
}

export function* shiftDetailReq() {
    yield takeLatest(ShiftActionTypes.SHIFT_DETAIL_REQUEST, handleShiftDetail)
}

function* handleShiftAssignEmployee({ payload }) {
    try {
        const response = yield call(shiftAssignEmployeeAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(assignShiftRequestSuccess(decryptedData))
            } else {
                yield put(assignShiftRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(assignShiftRequestError(error.response.data))
    }
}

export function* assignShiftReq() {
    yield takeLatest(ShiftActionTypes.ASSIGN_SHIFT_REQUEST, handleShiftAssignEmployee)
}

function* handleRequestShift({ payload }) {
    try {
        const response = yield call(requestShiftAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(requestShiftRequestSuccess(decryptedData))
            } else {
                yield put(requestShiftRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(requestShiftRequestError(error.response.data))
    }
}

export function* requestShiftReq() {
    yield takeLatest(ShiftActionTypes.REQUEST_SHIFT_REQUEST, handleRequestShift)
}

function* handleDeclineRequestShift({ payload }) {
    try {
        const response = yield call(declineRequestShiftAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(declineRequestShiftRequestSuccess(decryptedData))
            } else {
                yield put(declineRequestShiftRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(declineRequestShiftRequestError(error.response.data))
    }
}

export function* declineRequestShiftReq() {
    yield takeLatest(ShiftActionTypes.DECLINE_REQUEST_SHIFT_REQUEST, handleDeclineRequestShift)
}

function* handleAddShift({ payload }) {
    try {
        const response = yield call(addShiftAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addShiftRequestSuccess(decryptedData))
            } else {
                yield put(addShiftRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(addShiftRequestError(error.response.data))
    }
}

export function* addShiftReq() {
    yield takeLatest(ShiftActionTypes.ADD_SHIFT_REQUEST, handleAddShift)
}